import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PromiseStatuses } from "../../../../utils"
import { filtersDTO, NotImportResponseDTO } from "./dataService/dto"
import {  NewNotImportService } from "./dataService/service"

interface NotificationStructureState {
    onEdit: boolean
    GetAllImportResponse?: NotImportResponseDTO
    getAllImportRowsStatus: PromiseStatuses
    filtersUp: filtersDTO
}

const initialState: NotificationStructureState = {
    onEdit: false,
    getAllImportRowsStatus: 'idle',
    filtersUp: {
        page: 0,
        itemsPerPage: 0
    }
}

export const GetAllImportRows = createAsyncThunk(
    'Not/GetAllImportRows',
    async (filters: filtersDTO, thunkApi): Promise<NotImportResponseDTO> => {
        const NotImportService = NewNotImportService()
        return NotImportService.GetAllImport(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const NotificationImportSlice = createSlice({
    name: 'notificationImport/slice',
    initialState,
    reducers: {
        setOnEdit: (state, action) => {
            state.onEdit = action.payload
        },
        resetGetAllStatus: (state) => {
            state.getAllImportRowsStatus = 'idle'
        },
        resetFilters: (state) => {
            state.filtersUp = {
                page: 0,
                itemsPerPage: 0
            }
        }
    },
    extraReducers(builder) {
        builder

            .addCase(GetAllImportRows.pending, (state) => {
                state.getAllImportRowsStatus = 'loading'
            })
            .addCase(GetAllImportRows.fulfilled, (state, action) => {
                state.getAllImportRowsStatus = 'successfully'
                state.GetAllImportResponse = action.payload
            })
            .addCase(GetAllImportRows.rejected, (state, action) => {
                state.getAllImportRowsStatus = 'failed'
            })
    }
})

export const {
    setOnEdit,
    resetGetAllStatus
} = NotificationImportSlice.actions

export default NotificationImportSlice.reducer